module.exports = __webpack_public_path__ + "static/img/ico_speechbubble_pen.6fd7995.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico_speechbubble_pen.png
// module id = Zllk
// module chunks = 1